module.exports = __webpack_public_path__ + "static/intro_side-9fef5b4f21c99c936c848c12999d5242.png";